import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Apparition douce au scroll. Si l'utilisateur a demandé moins d'animations,
 * le contenu s'affiche directement, sans translation ni fondu.
 */
export default function Reveal({
  children,
  delay = 0,
  y = 24,
  as = 'div',
  className,
  ...rest
}) {
  const reduced = useReducedMotion();
  const Tag = motion[as] || motion.div;

  if (reduced) {
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
